import React, {useEffect, useState} from "react";
import {Button, Form, Input, message, Modal, Tag} from "antd";
import StandardInput from "./StandardInput";
import ArticleExtInput from "./ArticleExtInput";
import {request} from "../../util/request";
import RulesProblemModal from "./RulesProblemModal";
import {SortHandleIcon, TipsIcon} from "../icon/Icon";
import {BookOutlined, CloseCircleFilled, EyeInvisibleOutlined, EyeOutlined,} from '@ant-design/icons';
import {GLOBAL_RULES_PROBLEM_API, GLOBAL_TYPICAL_QUESTION_API} from "../../config/api";
import {getEllipsisText, ObjTest} from "jzfz-web-utils";
import {getArticleInfo} from '../../api/commonAPI';
import LearnDataModal from "./LearnDataModal";
import ReferTaskModal from "./ReferTaskModal";
import {arrayMove, SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';
import StandardMapSelect from "./StandardMapSelect";
import Abstract from "../abstract/Abstract";
import {auditStatusEnum, ModuleEnum} from "../../config/constant";
import ExamQuestionModal from "./ExamQuestionModal";
import TypicalProblemSelectModal from "./TypicalProblemSelectModal";
import './style/form.less';
import {getTitle} from "./utils";


const { Search } = Input;
// 拖拽手柄
const DragHandle = SortableHandle(() => (
    <SortHandleIcon title="拖拽可调整顺序" style={{ margin: '4px 10px 0 0', cursor: 'grab', color: '#999' }} />
));
// 非已通过典型问题title
const NOT_PASSED_TITLE = '非已通过的典型问题不会显示在浏览页面下';

// 各个类型知识去重
export const unique = (type: ModuleEnum, data: any[]) => {
    let fieldName = [];
    if (type === ModuleEnum.standard) {
        fieldName = ['articlePkid'];
    }
    if (type === ModuleEnum.rules) {
        fieldName = ['regulationPkid'];
    }
    if (type === ModuleEnum.learn) {
        fieldName = ['pkid'];
    }
    if (type === ModuleEnum.standardMap) {
        fieldName = ['pkid', 'figureNumber'];
    }
    if (type === ModuleEnum.typical) {
        fieldName = ['typicalProblemPkid'];
    }
    let keys = [];
    let tempList = data.filter((v: any) => {
        let key = fieldName.map((name: string) => v[name]).toString();
        if (!keys.includes(key)) {
            keys.push(key);
            return true;
        }
        return false;
    })

    return tempList;
}


export interface ConnectFormProps {
    moduleType?: number;    // 模块类型 0：帮助文档；1：典型性问题；2：公司规定问题；3：新国家规范；4：学习资料；5：标准任务；6：标准图集
    major?: number;  // 专业
    form: any;
    sortContainerZIndex?: number;   // 拖动容器的z-index
    shouldGetConnect?: boolean; // 是否要获取间接关联的数据 默认true
    showExtend?: boolean;   // 是否显示扩展阅读表单项
    showTypicalAbstract?: boolean;  // 是否显示典型问题摘要
    sortNameList?: string[]; // 表单项按名称排序
    hiddenFields?: string[];  // 需要隐藏的表单项
    indirectConnectData?: any;   // 间接关联的数据
    onGetIndirectData?: (values: any) => void;  // 获取间接关联数据
}


/**
 * 关联模块表单组件
 * @param props
 * @constructor
 */
const ConnectForm = (props: ConnectFormProps) => {
    const {
        moduleType,
        major: majorId,
        form,
        sortContainerZIndex = 1000,
        shouldGetConnect = true,
        showExtend = true,
        showTypicalAbstract = false,
        sortNameList = [],
        hiddenFields = [],
        indirectConnectData = {},
        onGetIndirectData = (values: any) => {},
    } = props;
    const major = Number(majorId);  // 专业转为number类型
    // 典型问题
    const [qulityCode, setQulityCode] = useState<string>('');
    const [qualityLoading, setQualityLoading] = useState<boolean>(false);
    // 规定问题
    const [rulesProblemCode, setRulesProblemCode] = useState<string>('');
    const [rulesProblemLoading, setRulesProblemLoading] = useState<boolean>(false);
    // 规定问题弹窗
    const [rulesProblemModalVisible, setRulesProblemModalVisible] = useState<boolean>(false);
    const [rulesProblemCheckedKeys, setRulesProblemCheckedKeys] = useState<string[]>([]);
    // 学习资料弹窗
    const [learnDataVisible, setLearnDataVisible] = useState<boolean>(false);
    const [learnDataCheckedKeys, setLearnDataCheckedKeys] = useState<string[]>([]);
    // 标准任务
    const [referTaskVisible, setReferTaskVisible] = useState<boolean>(false);
    const [referTaskFormData, setReferTaskFormData] = useState<any>({});
    const [referTaskCheckedKeys, setReferTaskCheckedKeys] = useState<string[]>([]);
    // 相关题目
    const [examQuestionVisible, setExamQuestionVisible] = useState<boolean>(false);
    const [examQuestionFormData, setExamQuestionFormData] = useState<any>({});
    // 典型问题选择弹窗
    const [typicalSelectModalVisible, setTypicalSelectModalVisible] = useState<boolean>(false);
    // 间接关联数据
    const { getFieldsValue, setFieldsValue, getFieldValue } = form;


    useEffect(() => {
        if (shouldGetConnect) {
            const {hiddenConnectIds} = indirectConnectData;
            setFieldsValue({hiddenConnectIds: hiddenConnectIds || []});
        }
    }, [indirectConnectData])


    /**
     * 查询间接关联数据
     * @param data 表单数据
     */
    const getIndirectData = () => {
        if (!shouldGetConnect) {
            return;
        }
        onGetIndirectData(getFieldsValue());
    }


    /**
     * 新增典型问题
     * @param value
     */
    const addTypicalProblem = (value: string) => {
        if (!value || !value.trim()) {
            message.error('请输入典型问题编号');
            return;
        }
        const {typicalConnects} = getFieldsValue();
        if (typicalConnects.map(v => v.typicalProblemPkid).includes(value)) {
            message.error('该典型问题编号已存在');
            return;
        }
        setQualityLoading(true);
        request('/typical-problem/exists', {problemId: value}, {method: 'get', baseURL: GLOBAL_TYPICAL_QUESTION_API}).then((res: any) => {
            if (!res.data) {
                message.warning(res.info);
                return;
            }
            setQulityCode('');
            typicalProblemChange([{typicalProblemPkid: value}]);
        }).finally(() => {
            setQualityLoading(false);
        });
    }


    /**
     * 更新典型问题表单值
     * @param pkids
     */
    const typicalProblemChange = (list: {typicalProblemPkid, status?, isRepeal?}[]) => {
        const { typicalConnects } = getFieldsValue();
        let newData = unique(ModuleEnum.typical, [...typicalConnects, ...list]);
        setFieldsValue({typicalConnects: newData});
        getIndirectData();
    }


    /**
     * 新增规定问题
     */
    const addRulesProblem = async (value: string) => {
        if (!value || !value.trim()) {
            message.error('请输入相关规定问题ID');
            return;
        }
        setRulesProblemLoading(true);
        let res = await request('/regulation/companyRegulation/verificationRegulation',
            {regulationCode: value}, {method: 'get', baseURL: GLOBAL_RULES_PROBLEM_API}).finally(() => {
            setRulesProblemLoading(false);
        });

        const { flag, regulationPkid, regulationCode } = res.data;
        if (!flag) {
            message.error('该规定问题不存在');
            return;
        }
        // 不能添加问题本身
        if (moduleType === ModuleEnum.rules) {
            const { regulationPkid: pkid } = getFieldsValue();
            if (pkid === regulationPkid) {
                message.error('不能添加该规定问题本身');
                return;
            }
        }
        const {regulationConnects} = getFieldsValue();
        if (regulationConnects.map(v => v.regulationPkid).includes(regulationPkid)) {
            message.error('该规定问题编号已存在');
            return;
        }
        // 根据pkid查询规定问题相关信息
        let queryRes = await request('/api/regulation/companyRegulationApi/selectRegulationsByIds',
            {regulationPkids: [regulationPkid]},
            {baseURL: GLOBAL_RULES_PROBLEM_API,
        });
        let values = queryRes.data.map((v: any) => {
            return {regulationPkid: v.regulationPkid, regulationPath: v.regulationPath, regulationSimpleContent: v.regulationSimpleContent};
        });
        setRulesProblemCode('');
        rulesProblemChange([...regulationConnects, ...values]);
    }


    /**
     * 更新规定问题表单值
     * @param values
     */
    const rulesProblemChange = (values: any[]) => {
        setFieldsValue({regulationConnects: values});
        getIndirectData();
    }


    /**
     * 显示规定问题选择弹窗
     */
    const showRulesProblemModal = () => {
        const { regulationConnects } = getFieldsValue();
        setRulesProblemCheckedKeys(regulationConnects.map(v => v.regulationPkid));
        setRulesProblemModalVisible(true)
    }


    /**
     * 显示学习资料弹窗
     */
    const showLearnDataModal = () => {
        const { learnMaterialConnects } = getFieldsValue();
        setLearnDataCheckedKeys(learnMaterialConnects.map(v => v.pkid));
        setLearnDataVisible(true);
    }


    /**
     * 显示引用标准任务弹窗
     */
    const showReferTaskModal = () => {
        const { standardMissionConnects } = getFieldsValue()
        let pkids = (standardMissionConnects || []).map((v: any) => v.pkid);
        setReferTaskVisible(true);
        setReferTaskFormData({major: 1, checkedKeys: pkids});
        setReferTaskCheckedKeys(pkids);
    }


    /**
     * 显示相关题目弹窗
     */
    const showExamQuestionModal = () => {
        const { questionConnects } = getFieldsValue()
        let pkids = (questionConnects || []).map((v: any) => v.pkid);
        setExamQuestionVisible(true);
        setExamQuestionFormData({major, checkedKeys: pkids});
    }


    /**
     * 拖动排序结束触发
     * @param oldIndex
     * @param newIndex
     * @param fieldName
     */
    const sortEnd = ({oldIndex, newIndex}, fieldName: string) => {
        let items = [...getFieldValue(fieldName)];
        setFieldsValue({[fieldName]: arrayMove(items, oldIndex, newIndex)});
    }


    /**
     * 相关典型问题-可排序列表
     */
    const TypicalProblemList = SortableContainer(({items, remove}) => {
        const SortableItem = SortableElement(({value}) => {
            const { key, name, fieldKey, ...restField } = value;
            let info = getFieldValue('typicalConnects')[name] || {};
            const { typicalProblemPkid, isRepeal, status } = info;
            let title = getTitle(ModuleEnum.typical, info);
            return (
                <div
                    className="connect-list-item"
                    key={key}
                    style={{zIndex: sortContainerZIndex}}
                >
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <DragHandle />
                        { isRepeal && <span className="invalid-label">已作废</span> }
                        {
                            status > 0 && status !== 7 && (
                                <span
                                    className="typical-problem-status-label"
                                    title={NOT_PASSED_TITLE}
                                >{auditStatusEnum[status] || ''}
                                </span>
                            )
                        }
                        <Abstract type={ModuleEnum.typical} pkid={typicalProblemPkid} >
                            <span className="connect-list-item-text" title={title}>{title}</span>
                        </Abstract>
                    </Form.Item>
                    <CloseCircleFilled
                        className="ml15 form-close-btn"
                        onClick={() => {
                            remove(name);
                            getIndirectData();
                        }}
                    />
                    <Form.Item
                        {...restField}
                        name={[name, 'typicalProblemPkid']}
                        fieldKey={[fieldKey, 'typicalProblemPkid']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                </div>
            )
        });

        return (
            <div>
                {items.map((value, index) => (
                    <SortableItem key={index} index={index} value={value} />
                ))}
            </div>
        );
    });


    /**
     * 相关规定问题-可排序列表
     */
    const RulesProblemList = SortableContainer(({items, remove}) => {
        const SortableItem = SortableElement(({value}) => {
            const { key, name, fieldKey, ...restField } = value;
            let info = getFieldValue('regulationConnects')[name] || {};
            const { regulationPkid, isRepeal } = info;
            let title = getTitle(ModuleEnum.rules, info);
            return (
                <div
                    className="connect-list-item"
                    key={key}
                    style={{zIndex: sortContainerZIndex}}
                >
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <DragHandle />
                        { isRepeal && <span className="invalid-label">已作废</span> }
                        <Abstract type={ModuleEnum.rules} pkid={regulationPkid} >
                            <span
                                className="connect-list-item-text"
                                title={title}
                            >{title}
                            </span>
                        </Abstract>
                    </Form.Item>
                    <CloseCircleFilled
                        className="ml15 form-close-btn"
                        onClick={() => {
                            remove(name);
                            getIndirectData();
                        }}
                    />
                    <Form.Item
                        {...restField}
                        name={[name, 'regulationPkid']}
                        fieldKey={[fieldKey, 'regulationPkid']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                </div>
            )
        });

        return (
            <div>
                {items.map((value, index) => (
                    <SortableItem key={index} index={index} value={value} />
                ))}
            </div>
        );
    });


    /**
     * 国家规范-可排序列表
     */
    const StandardList = SortableContainer(({items, remove}) => {
        const SortableItem = SortableElement(({value}) => {
            const { key, name, fieldKey, ...restField } = value;
            let info = getFieldValue('articleConnects')[name] || {};
            const { isExistStandard, articlePkid, isRepeal } = info;
            let title = getTitle(ModuleEnum.standard, info);
            return (
                <div
                    className="connect-list-item"
                    key={key}
                    style={{zIndex: sortContainerZIndex}}
                >
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <DragHandle />
                        { isRepeal && <span className="invalid-label">已作废</span> }
                        {
                            isExistStandard === 0
                                ? (
                                    <TipsIcon
                                        className="mr5 f16"
                                        title="该规范尚未收录，只能显示规范名称，无法显示规范内容。我们将尽快补齐"
                                        style={{color: '#999'}}
                                    />
                                )
                                : null
                        }
                        <Abstract type={ModuleEnum.standard} pkid={articlePkid} >
                            <span
                                className="connect-list-item-text"
                                title={title}
                                style={isExistStandard === 0 ? {color: '#999'} : {}}
                            >{title}</span>
                        </Abstract>
                    </Form.Item>
                    <CloseCircleFilled
                        className="ml15 form-close-btn"
                        onClick={() => {
                            remove(name);
                            getIndirectData();
                        }}
                    />
                    <Form.Item
                        {...restField}
                        name={[name, 'articleCode']}
                        fieldKey={[fieldKey, 'articleCode']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'articlePkid']}
                        fieldKey={[fieldKey, 'articlePkid']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'standardName']}
                        fieldKey={[fieldKey, 'standardName']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'standardPkid']}
                        fieldKey={[fieldKey, 'standardPkid']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'isExistStandard']}
                        fieldKey={[fieldKey, 'isExistStandard']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                </div>
            )
        });

        return (
            <div>
                {items.map((value, index) => (
                    <SortableItem key={index} index={index} value={value} />
                ))}
            </div>
        );
    });


    /**
     * 学习资料-可排序列表
     */
    const LearnDataList = SortableContainer(({items, remove}) => {
        const SortableItem = SortableElement(({value}) => {
            const { key, name, fieldKey, ...restField } = value;
            let info = getFieldValue('learnMaterialConnects')[name] || {};
            const { isRepeal } = info;
            let title = getTitle(ModuleEnum.learn, info);
            return (
                <div
                    className="connect-list-item"
                    key={key}
                    style={{zIndex: sortContainerZIndex}}
                >
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <DragHandle />
                        { isRepeal && <span className="invalid-label">已作废</span> }
                        <span className="connect-list-item-text" title={title}>{title}</span>
                    </Form.Item>
                    <CloseCircleFilled
                        className="ml15 form-close-btn"
                        onClick={() => {
                            remove(name);
                            getIndirectData();
                        }}
                    />
                    <Form.Item
                        {...restField}
                        name={[name, 'pkid']}
                        fieldKey={[fieldKey, 'pkid']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                </div>
            )
        });

        return (
            <div>
                {items.map((value, index) => (
                    <SortableItem key={index} index={index} value={value} />
                ))}
            </div>
        );
    });


    /**
     * 标准图集-可排序列表
     */
    const StandardMapList = SortableContainer(({items, remove}) => {
        const SortableItem = SortableElement(({value}) => {
            const { key, name, fieldKey, ...restField } = value;
            let info = getFieldValue('standardMapConnects')[name] || {};
            const { mapCode, mapName, fullNamePath, mapPage, figureNumber, isRepeal } = info;
            let title = getTitle(ModuleEnum.standardMap, info);
            return (
                <div
                    className="connect-list-item"
                    key={key}
                    style={{zIndex: sortContainerZIndex}}
                >
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <DragHandle />
                        { isRepeal && <span className="invalid-label">已作废</span> }
                        <span className="connect-list-item-text" title={title}>{title}
                        </span>
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'pkid']}
                        fieldKey={[fieldKey, 'pkid']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'figureNumber']}
                        fieldKey={[fieldKey, 'figureNumber']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                    <CloseCircleFilled
                        className="ml15 form-close-btn"
                        onClick={() => {
                            remove(name);
                            getIndirectData();
                        }}
                    />
                </div>
            )
        });

        return (
            <div>
                {items.map((value, index) => (
                    <SortableItem key={index} index={index} value={value} />
                ))}
            </div>
        );
    });


    /**
     * 扩展阅读-可排序列表
     */
    const ExtendReadList = SortableContainer(({items, remove}) => {
        const SortableItem = SortableElement(({value}) => {
            const { key, name, fieldKey, ...restField } = value;
            const { title, link } = getFieldValue('extendReads')[name] || {};
            return (
                <div
                    className="connect-list-item"
                    key={key}
                    style={{zIndex: sortContainerZIndex}}
                >
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <DragHandle />
                        {
                            link
                                ? <a className="connect-list-item-text" href={link} target="_blank">{title}</a>
                                : <span className="connect-list-item-text">{title}</span>
                        }
                    </Form.Item>
                    <CloseCircleFilled
                        className="ml15 form-close-btn"
                        onClick={() => {
                            remove(name);
                            getIndirectData();
                        }}
                    />
                    <Form.Item
                        {...restField}
                        name={[name, 'title']}
                        fieldKey={[fieldKey, 'title']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        name={[name, 'link']}
                        fieldKey={[fieldKey, 'link']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                </div>
            )
        });

        return (
            <div>
                {items.map((value, index) => (
                    <SortableItem key={index} index={index} value={value} />
                ))}
            </div>
        );
    });


    /**
     * 标准任务-可排序列表
     */
    const StandardTaskList = SortableContainer(({items, remove}) => {
        const SortableItem = SortableElement(({value}) => {
            const { key, name, fieldKey, ...restField } = value;
            let info = getFieldValue('standardMissionConnects')[name] || {};
            const { taskStatus, isRepeal } = info;
            let title = getTitle(ModuleEnum.standardTask, info);
            return (
                <div
                    className="connect-list-item"
                    key={key}
                    style={{zIndex: sortContainerZIndex}}
                >
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <DragHandle />
                        { isRepeal && <span className="invalid-label">已作废</span> }
                        <span className="connect-list-item-text" title={title}>{title}</span>
                    </Form.Item>
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <span>{taskStatus}</span>
                    </Form.Item>
                    <CloseCircleFilled
                        className="ml15 form-close-btn"
                        onClick={() => {
                            remove(name);
                            getIndirectData();
                        }}
                    />
                    <Form.Item
                        {...restField}
                        name={[name, 'pkid']}
                        fieldKey={[fieldKey, 'pkid']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                </div>
            )
        });

        return (
            <div>
                {items.map((value, index) => (
                    <SortableItem key={index} index={index} value={value} />
                ))}
            </div>
        );
    });


    /**
     * 新增国家规范
     * @param values
     */
    const standardChange = (values: any[]) => {
        const { articleConnects } = getFieldsValue();
        setFieldsValue({articleConnects: unique(ModuleEnum.standard, [...articleConnects, ...values])});
        getIndirectData();
    }


    /**
     * 变更间接关联显隐表单值
     * @param checked
     * @param pkids
     */
    const changeHiddenValus = (checked: boolean, pkid: string) => {
        const { hiddenConnectIds } = getFieldsValue();
        if (checked) {  // 点击隐藏
            let values = Array.from(new Set([...hiddenConnectIds, pkid]));
            setFieldsValue({hiddenConnectIds: values});
        }else { // 点击显示
            let values = hiddenConnectIds.filter((v: any) => v !== pkid);
            setFieldsValue({hiddenConnectIds: values});
        }
    }


    /**
     * 获取间接关联显隐按钮
     * @param pkid
     */
    const getVisibleBtn = (pkid: string): React.ReactNode => {
        return (
            <Form.Item shouldUpdate noStyle>
                {() => {
                    const { hiddenConnectIds } = getFieldsValue();
                    if ((hiddenConnectIds || []).includes(pkid)) {
                        return (
                            <EyeInvisibleOutlined
                                className="ml5"
                                title="点击显示"
                                style={{fontSize: 16, color: '#595959'}}
                                onClick={() => {
                                    changeHiddenValus(false, pkid);
                                }}
                            />
                        )
                    }
                    return (
                        <EyeOutlined
                            className="ml5"
                            title="点击隐藏"
                            style={{fontSize: 16, color: '#595959'}}
                            onClick={() => {
                                changeHiddenValus(true, pkid);
                            }}
                        />
                    )
                }}
            </Form.Item>
        )
    }


    /**
     * 间接转直接
     * @param type
     * @param data
     */
    const convertToDirect = (type: ModuleEnum, data: any) => {
        Modal.confirm({
            content: '确定要转为直接关联吗？',
            cancelText: null,
            okButtonProps: {className: 'button-red'},
            onOk: () => {
                // 国家规范
                if (type === ModuleEnum.standard) {
                    const { standardPkid, standardName, standardCode, articlePkid, articleCode, isRepeal, isExistStandard } = data;
                    standardChange([{standardPkid, standardName, standardCode, articlePkid, articleCode, isRepeal, isExistStandard}]);
                }
                // 典型问题
                if (type === ModuleEnum.typical) {
                    const { typicalProblemPkid, status, isRepeal } = data;
                    typicalProblemChange([{typicalProblemPkid, status, isRepeal}]);
                }
                // 规定问题
                if (type === ModuleEnum.rules) {
                    const { regulationConnects } = getFieldsValue();
                    const { regulationPkid, regulationPath, regulationSimpleContent, isRepeal } = data;
                    rulesProblemChange([...regulationConnects, {regulationPkid, regulationPath, regulationSimpleContent, isRepeal}]);
                }
                // 标准任务
                if (type === ModuleEnum.standardTask) {
                    const { standardMissionConnects } = getFieldsValue();
                    const { pkid, name, isRepeal } = data;
                    standardTaskChange([...standardMissionConnects, {pkid, name, isRepeal}]);
                }
                // 学习资料
                if (type === ModuleEnum.learn) {
                    const { learnMaterialConnects } = getFieldsValue();
                    const { pkid, name, isRepeal } = data;
                    learnDataChange([...learnMaterialConnects, {pkid, name, isRepeal}]);
                }
                // 标准题库
                if (type === ModuleEnum.exam) {
                    const { questionConnects } = getFieldsValue();
                    const { pkid, content, isRepeal } = data;
                    examQuestionChange([...questionConnects, {pkid, content, isRepeal}]);
                }
                // 标准图集
                if (type === ModuleEnum.standardMap) {
                    const { pkid, mapPage, mapName, mapCode, fullNamePath, figureNumber, isRepeal } = data;
                    standardMapChange([{pkid, mapPage, mapName, mapCode, fullNamePath, figureNumber, isRepeal}]);
                }
            }
        })
    }


    /**
     * 国家规范表单项
     */
    const getStandardFormItem = (): React.ReactNode => (
        <div className="standard-form-input mb25" hidden={hiddenFields.includes('standard')}>
            <Form.Item className="mb0" label="涉及规范">
                <StandardInput
                    moduleType={moduleType}
                    form={form}
                    onChange={standardChange}
                />
            </Form.Item>
            <Form.List name="articleConnects" initialValue={[]}>
                {(fields, { add, remove }) => (
                    <StandardList
                        items={fields}
                        remove={remove}
                        useDragHandle
                        onSortEnd={(values: any) => sortEnd(values, 'articleConnects')}
                    />
                )}
            </Form.List>
            <ul className="undirect-list" hidden={!shouldGetConnect}>
                {
                    (indirectConnectData.articleConnects || []).map((v: any, i: number) => (
                        <li key={i}>
                            {v.isRepeal && <span className="invalid-label">已作废</span>}
                            <Abstract type={ModuleEnum.standard} pkid={v.pkid} >
                                <span>{getTitle(ModuleEnum.standard, v)}</span>
                            </Abstract>
                            <Tag className="ml10 convert-btn" onClick={() => convertToDirect(ModuleEnum.standard, v)}>转为直接关联</Tag>
                            { getVisibleBtn(v.pkid) }
                        </li>
                    ))
                }
            </ul>
        </div>
    )


    /**
     * 典型问题表单项
     */
    const getTypicalQuestionFormItem = () => (
        <div className="typical-form-input mb25" hidden={hiddenFields.includes('typicalQuestion')}>
            <Form.Item className="mb0" label="典型问题">
                <Search
                    className="enter-btn-wrap"
                    allowClear
                    value={qulityCode}
                    enterButton={<Button type="primary" disabled={!qulityCode}>确认添加</Button>}
                    onSearch={(value: string) => {
                        addTypicalProblem(value);
                    }}
                    onChange={(e: any) => {
                        setQulityCode(e.target.value);
                    }}
                />
                <Button
                    className="select-btn ml15"
                    title="选取规定问题"
                    icon={<BookOutlined />}
                    onClick={() => setTypicalSelectModalVisible(true)}
                >选择
                </Button>
            </Form.Item>
            <Form.List name="typicalConnects" initialValue={[]}>
                {(fields, { add, remove }) => (
                    <TypicalProblemList
                        items={fields}
                        remove={remove}
                        useDragHandle
                        onSortEnd={(values: any) => sortEnd(values, 'typicalConnects')}
                    />
                )}
            </Form.List>
            <ul className="undirect-list" hidden={!shouldGetConnect}>
                {
                    (indirectConnectData.typicalConnects || []).map((v: any, i: number) => (
                        <li key={i}>
                            {v.isRepeal && <span className="invalid-label">已作废</span>}
                            {
                                v.status > 0 && v.status !== 7 && (
                                    <span
                                        className="typical-problem-status-label"
                                        title={NOT_PASSED_TITLE}
                                    >{auditStatusEnum[v.status] || ''}
                                    </span>
                                )
                            }
                            <Abstract type={ModuleEnum.typical} pkid={v.pkid} >
                                <span>{getTitle(ModuleEnum.typical, v)}</span>
                            </Abstract>
                            <Tag className="ml10 convert-btn" onClick={() => convertToDirect(ModuleEnum.typical, v)}>转为直接关联</Tag>
                            { getVisibleBtn(v.pkid) }
                        </li>
                    ))
                }
            </ul>
        </div>
    )


    /**
     * 规定问题表单项
     */
    const getRulesProblemFormItem = () => (
        <div className="rules-problem-form-input mb25" hidden={hiddenFields.includes('rulesProblem')}>
            <Form.Item className="mb0" label="规定问题">
                <Search
                    className="enter-btn-wrap"
                    allowClear
                    value={rulesProblemCode}
                    enterButton={<Button type="primary" disabled={!rulesProblemCode}>确认添加</Button>}
                    onSearch={(value: string) => {
                        addRulesProblem(value);
                    }}
                    onChange={(e: any) => {
                        setRulesProblemCode(e.target.value);
                    }}
                />
                <Button
                    className="select-btn ml15"
                    title="选取规定问题"
                    icon={<BookOutlined />}
                    onClick={showRulesProblemModal}
                >选择
                </Button>
            </Form.Item>
            <Form.List name="regulationConnects" initialValue={[]}>
                {(fields, { add, remove }) => (
                    <RulesProblemList
                        items={fields}
                        remove={remove}
                        useDragHandle
                        onSortEnd={(values: any) => sortEnd(values, 'regulationConnects')}
                    />
                )}
            </Form.List>
            <ul className="undirect-list" hidden={!shouldGetConnect}>
                {
                    (indirectConnectData.regulationConnects || []).map((v: any, i: number) => (
                        <li key={i}>
                            {v.isRepeal && <span className="invalid-label">已作废</span>}
                            <Abstract type={ModuleEnum.rules} pkid={v.pkid} >
                                <span>{getTitle(ModuleEnum.rules, v)}</span>
                            </Abstract>
                            <Tag className="ml10 convert-btn" onClick={() => convertToDirect(ModuleEnum.rules, v)}>转为直接关联</Tag>
                            { getVisibleBtn(v.pkid) }
                        </li>
                    ))
                }
            </ul>
        </div>
    )


    /**
     * 更新标准任务表单值
     * @param values
     */
    const standardTaskChange = (values: any[]) => {
        setFieldsValue({standardMissionConnects: values});
        getIndirectData();
    }


    /**
     * 标准任务表单项
     */
    const getStandardTask = () => (
        <div className="mb25" hidden={hiddenFields.includes('standardTask')}>
            <Form.Item className="mb0" label="标准任务">
                <Button className="select-btn" icon={<BookOutlined />} onClick={showReferTaskModal}>选择</Button>
            </Form.Item>
            <Form.List name="standardMissionConnects" initialValue={[]}>
                {(fields, { add, remove }) => (
                    <StandardTaskList
                        items={fields}
                        remove={remove}
                        useDragHandle
                        onSortEnd={(values: any) => sortEnd(values, 'standardMissionConnects')}
                    />
                )}
            </Form.List>
            <ul className="undirect-list" hidden={!shouldGetConnect}>
                {
                    (indirectConnectData.standardMissionConnects || []).map((v: any, i: number) => (
                        <li key={i}>
                            {v.isRepeal && <span className="invalid-label">已作废</span>}
                            <span>{getTitle(ModuleEnum.standardTask, v)}</span>
                            <Tag className="ml10 convert-btn" onClick={() => convertToDirect(ModuleEnum.standardTask, v)}>转为直接关联</Tag>
                            { getVisibleBtn(v.pkid) }
                        </li>
                    ))
                }
            </ul>
        </div>
    )


    /**
     * 更新学习资料表单值
     * @param values
     */
    const learnDataChange = (values: any[]) => {
        setFieldsValue({learnMaterialConnects: values});
        getIndirectData();
    }


    /**
     * 学习资料表单项
     */
    const getLearnDataFormItem = () => (
        <div className="mb25" hidden={hiddenFields.includes('learnData')}>
            <Form.Item className="mb0" label="学习资料">
                <Button
                    className="select-btn"
                    icon={<BookOutlined />}
                    onClick={showLearnDataModal}
                >选择
                </Button>
            </Form.Item>
            <Form.List name="learnMaterialConnects" initialValue={[]}>
                {(fields, { add, remove }) => (
                    <LearnDataList
                        items={fields}
                        remove={remove}
                        useDragHandle
                        onSortEnd={(values: any) => sortEnd(values, 'learnMaterialConnects')}
                    />
                )}
            </Form.List>
            <ul className="undirect-list" hidden={!shouldGetConnect}>
                {
                    (indirectConnectData.learnMaterialConnects || []).map((v: any, i: number) => (
                        <li key={i}>
                            {v.isRepeal && <span className="invalid-label">已作废</span>}
                            <span>{getTitle(ModuleEnum.learn, v)}</span>
                            <Tag className="ml10 convert-btn" onClick={() => convertToDirect(ModuleEnum.learn, v)}>转为直接关联</Tag>
                            { getVisibleBtn(v.pkid) }
                        </li>
                    ))
                }
            </ul>
        </div>
    )



    /**
     * 相关题目-可排序列表
     */
    const ExamQuestionList = SortableContainer(({items, remove}) => {
        const SortableItem = SortableElement(({value}) => {
            const { key, name, fieldKey, ...restField } = value;
            let info = getFieldValue('questionConnects')[name] || {};
            const { isRepeal } = info;
            let title = getTitle(ModuleEnum.exam, info);
            return (
                <div
                    className="connect-list-item"
                    key={key}
                    style={{zIndex: sortContainerZIndex}}
                >
                    <Form.Item
                        {...restField}
                        noStyle
                    >
                        <DragHandle />
                        { isRepeal && <span className="invalid-label">已作废</span> }
                        <span className="connect-list-item-text" title={title}>{getEllipsisText(title, 100)}</span>
                    </Form.Item>
                    <CloseCircleFilled
                        className="ml15 form-close-btn"
                        onClick={() => {
                            remove(name);
                            getIndirectData();
                        }}
                    />
                    <Form.Item
                        {...restField}
                        name={[name, 'pkid']}
                        fieldKey={[fieldKey, 'pkid']}
                        hidden
                    >
                        <Input type="hidden" />
                    </Form.Item>
                </div>
            )
        });

        return (
            <div>
                {items.map((value, index) => (
                    <SortableItem key={index} index={index} value={value} />
                ))}
            </div>
        );
    });


    /**
     * 更新标准题库表单值
     * @param values
     */
    const examQuestionChange = (values: any[]) => {
        setFieldsValue({questionConnects: values});
        getIndirectData();
    }


    /**
     * 标准题库
     */
    const getExamQuestion = () => (
        <div className="mb25" hidden={hiddenFields.includes('examQuestion')}>
            <Form.Item className="mb0" label="相关题目">
                <Button className="select-btn" icon={<BookOutlined />} onClick={showExamQuestionModal}>选择</Button>
            </Form.Item>
            <Form.List name="questionConnects" initialValue={[]}>
                {(fields, { add, remove }) => (
                    <ExamQuestionList
                        items={fields}
                        remove={remove}
                        useDragHandle
                        onSortEnd={(values: any) => sortEnd(values, 'questionConnects')}
                    />
                )}
            </Form.List>
            <ul className="undirect-list" hidden={!shouldGetConnect}>
                {
                    (indirectConnectData.questionConnects || []).map((v: any, i: number) => (
                        <li key={i}>
                            {v.isRepeal && <span className="invalid-label">已作废</span>}
                            <span>{getTitle(ModuleEnum.exam, v)}</span>
                            <Tag className="ml10 convert-btn" onClick={() => convertToDirect(ModuleEnum.exam, v)}>转为直接关联</Tag>
                            { getVisibleBtn(v.pkid) }
                        </li>
                    ))
                }
            </ul>
        </div>
    )


    /**
     * 增加图集
     * @param values
     */
    const standardMapChange = (values: any[]) => {
        const { standardMapConnects } = getFieldsValue();
        setFieldsValue({standardMapConnects: unique(ModuleEnum.standardMap, [...standardMapConnects, ...values])});
        getIndirectData();
    }


    /**
     * 标准图集表单项
     */
    const getStandardMapFormItem = () => (
        <div className="standard-map-form-input mb25" hidden={hiddenFields.includes('standardMap')}>
            <Form.Item className="mb0" label="相关图集">
                <StandardMapSelect
                    moduleType={moduleType}
                    form={form}
                    onChange={standardMapChange}
                />
            </Form.Item>
            <Form.List name="standardMapConnects" initialValue={[]}>
                {(fields, { add, remove }) => (
                    <StandardMapList
                        items={fields}
                        remove={remove}
                        useDragHandle
                        onSortEnd={(values: any) => sortEnd(values, 'standardMapConnects')}
                    />
                )}
            </Form.List>
            <ul className="undirect-list" hidden={!shouldGetConnect}>
                {
                    (indirectConnectData.standardMapConnects || []).map((v: any, i: number) => (
                        <li key={i}>
                            {v.isRepeal && <span className="invalid-label">已作废</span>}
                            <span>{getTitle(ModuleEnum.standardMap, v)}</span>
                            <Tag className="ml10 convert-btn" onClick={() => convertToDirect(ModuleEnum.standardMap, v)}>转为直接关联</Tag>
                            { getVisibleBtn(v.pkid) }
                        </li>
                    ))
                }
            </ul>
        </div>
    )


    /**
     * 扩展阅读表单项
     */
    const getExtendReadFormItem = () => (
        <div className="extend-read-form-input mb25" hidden={hiddenFields.includes('extendRead') || !showExtend}>
            <Form.Item className="mb0" label="扩展阅读">
                <ArticleExtInput
                    form={form}
                    onChange={(values: any) => {
                        const { extendReads } = getFieldsValue();
                        setFieldsValue({extendReads: [...extendReads, values]});
                    }}
                />
            </Form.Item>
            <Form.List name="extendReads" initialValue={[]}>
                {(fields, { add, remove }) => (
                    <ExtendReadList
                        items={fields}
                        remove={remove}
                        useDragHandle
                        onSortEnd={(values: any) => sortEnd(values, 'extendReads')}
                    />
                )}
            </Form.List>
        </div>
    )


    const getFormItemByOrder = () => {
        let tempList = [
            {
                name: 'standard',
                component: getStandardFormItem(),
            },
            {
                name: 'typicalQuestion',
                component: getTypicalQuestionFormItem(),
            },
            {
                name: 'rulesProblem',
                component: getRulesProblemFormItem(),
            },
            {
                name: 'standardTask',
                component: getStandardTask(),
            },
            {
                name: 'learnData',
                component: getLearnDataFormItem(),
            },
            {
                name: 'examQuestion',
                component: getExamQuestion(),
            },
            {
                name: 'standardMap',
                component: getStandardMapFormItem(),
            },
            {
                name: 'extendRead',
                component: getExtendReadFormItem(),
            }
        ]

        if (ObjTest.isNotEmptyArray(sortNameList)) {
            tempList.sort((p: any, n: any) => {
                return sortNameList.indexOf(p.name) - sortNameList.indexOf(n.name);
            })
        }

        return tempList;
    }


    /**
     * 获取典型问题摘要
     */
    const getTypicalAbstract = () => {
        return (
            showTypicalAbstract && ObjTest.isNotEmptyArray(indirectConnectData.typicalConnects) && (
                <div className="typical-problem-abstract mb25">
                    <div className="typical-problem-abstract-title">以下典型问题也关联了相同知识，请检查是否已有同类问题，避免重复上传：</div>
                    {
                        (indirectConnectData.typicalConnects || []).map((v: any, i: number) => (
                            <div className="typical-problem-abstract-item" key={i}>
                                <div className="flexic">
                                    <div>
                                        <span className="typical-problem-abstract-id">ID：{v.typicalProblemPkid}</span>
                                    </div>
                                    <Button
                                        className="typical-problem-abstract-btn"
                                        type="link"
                                        size="small"
                                        onClick={async () => {
                                            const { url } = await getArticleInfo({appType: ModuleEnum.typical, pkid: v.pkid});
                                            window.open(url, '_blank');
                                        }}
                                    >查看详情</Button>
                                </div>
                                <div className="typical-problem-abstract-content" title={v.typicalProblemName}>{v.typicalProblemName}</div>
                            </div>
                        ))
                    }
                </div>
            )
        )
    }


    return (
        <div className="connect-form-wrapper">
            <>
            {
                getFormItemByOrder().map((v: any, i: number) => (
                    <React.Fragment key={i}>
                        {v.component}
                    </React.Fragment>
                ))
            }
            { getTypicalAbstract() }
            <Form.Item name="hiddenConnectIds" initialValue={[]} hidden>
                <Input type="hidden" />
            </Form.Item>
            </>
            <RulesProblemModal
                moduleType={moduleType}
                form={form}
                defaultCheckedKeys={rulesProblemCheckedKeys}
                visible={rulesProblemModalVisible}
                onSubmit={(values: any[]) => {
                    setRulesProblemModalVisible(false);
                    rulesProblemChange(values);
                }}
                onCancel={() => setRulesProblemModalVisible(false)}
            />
            <LearnDataModal
                moduleType={moduleType}
                form={form}
                defaultCheckedKeys={learnDataCheckedKeys}
                visible={learnDataVisible}
                onSubmit={(values: any[]) => {
                    setLearnDataVisible(false);
                    learnDataChange(values);
                }}
                onCancel={() => setLearnDataVisible(false)}
            />
            <ReferTaskModal
                moduleType={moduleType}
                form={form}
                defaultCheckedKeys={referTaskCheckedKeys}
                visible={referTaskVisible}
                formData={referTaskFormData}
                onSubmit={(values: any[]) => {
                    setReferTaskVisible(false);
                    standardTaskChange(values);
                }}
                onCancel={() => setReferTaskVisible(false)}
            />
            <ExamQuestionModal
                moduleType={moduleType}
                form={form}
                visible={examQuestionVisible}
                formData={examQuestionFormData}
                onSubmit={(values: any[]) => {
                    setExamQuestionVisible(false);
                    examQuestionChange(values);
                }}
                onCancel={() => setExamQuestionVisible(false)}
            />
            <TypicalProblemSelectModal
                visible={typicalSelectModalVisible}
                onCancel={() => setTypicalSelectModalVisible(false)}
                onSubmit={(pkids: string[]) => {
                    setTypicalSelectModalVisible(false);
                    typicalProblemChange(pkids.map((v: any) => ({typicalProblemPkid: v})));
                }}
            />
        </div>
    )
}


export default ConnectForm;
